import { FooterComponentData, UIConstants } from '@constants';
import { BoxBase, LinkBase, StackBase, TypographyBase } from '@fmc-digital/ui';
import { Link, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { AppStoreIcon, CopyrightIcon, EqualOpportunityIcon, GooglePlayIcon } from '../icons';

const { nmlsConsumerLink, footerLinks } = FooterComponentData;
const { smartLink } = UIConstants.promotionWidget;

const MobileFooter = () => {
    const theme = useTheme();

    return (
        <>
            <BoxBase
                sx={theme => ({
                    display: 'flex',
                    padding: theme.spacing(2),
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: theme.spacing(2),
                    background: theme.palette.surface.main
                })}
            >
                <TypographyBase variant="caption" color="white">
                    Available on
                </TypographyBase>
                <LinkBase href={smartLink} target="_blank" underline="none">
                    <StackBase gap="0.5rem" direction="row" alignItems="center">
                        <GooglePlayIcon sx={{ width: '0.917rem', height: '1rem' }} />
                        <TypographyBase color="white" variant="caption" lineHeight="0.975rem !important">
                            Google Play
                        </TypographyBase>
                        <AppStoreIcon sx={{ width: '0.875rem', height: '1rem' }} />
                        <TypographyBase color="white" variant="caption" lineHeight="0.975rem !important">
                            App Store
                        </TypographyBase>
                    </StackBase>
                </LinkBase>
            </BoxBase>
            <StackBase
                spacing="1rem"
                padding="1rem"
                alignItems="flex-start"
                sx={theme => ({
                    background: theme.palette.surfaceDark.main
                })}
            >
                <TypographyBase variant="caption" color="white">
                    951 Yamato Road, Boca Raton, FL 33431
                    <br />
                    United States.
                </TypographyBase>
                <BoxBase
                    sx={theme => ({
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: theme.spacing(2)
                    })}
                >
                    <TypographyBase variant="caption" color="text.main">
                        Lender NMLS ID: 2767.
                        <br />
                        <LinkBase
                            href={nmlsConsumerLink.link}
                            variant="caption"
                            rel="noopener noreferrer"
                            target="_blank"
                            color="text.main"
                            underline="hover"
                            sx={{ '&:hover': { color: 'text.main' } }}
                        >
                            {nmlsConsumerLink.text}
                        </LinkBase>
                        <br />
                        Equal Housing Opportunity.
                    </TypographyBase>
                    <EqualOpportunityIcon sx={{ width: '1.875rem', height: '2.063rem' }} />
                </BoxBase>
                <StackBase direction="row" sx={{ flexWrap: 'wrap' }}>
                    {footerLinks.map(({ link, text }, index) => {
                        return (
                            <StackBase direction="row" key={index}>
                                <LinkBase
                                    href={link}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                    variant="caption"
                                    sx={{ display: 'flex', alignItems: 'center', color: 'text.main', '&:hover': { color: 'text.main' } }}
                                >
                                    {text}
                                </LinkBase>
                                {footerLinks.length !== index + 1 && (
                                    <TypographyBase
                                        variant="caption"
                                        color="text.main"
                                        sx={{ display: 'flex', alignItems: 'center', marginX: theme.spacing(1) }}
                                    >
                                        |
                                    </TypographyBase>
                                )}
                            </StackBase>
                        );
                    })}
                </StackBase>
                <BoxBase
                    sx={theme => ({
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: theme.spacing(0.5)
                    })}
                >
                    <CopyrightIcon sx={{ width: '0.6875rem', height: '0.71331rem', mb: '0.05rem' }} />
                    <TypographyBase variant="caption" color="text.main" sx={{ lineHeight: '120%' }}>
                        Freedom Mortgage Corporation.
                    </TypographyBase>
                </BoxBase>
            </StackBase>
        </>
    );
};
const TabletFooter = () => {
    const theme = useTheme();

    return (
        <>
            <BoxBase
                sx={theme => ({
                    display: 'flex',
                    padding: theme.spacing(2),
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: theme.spacing(2),
                    background: theme.palette.surface.main
                })}
            >
                <TypographyBase variant="paragraph" color="white">
                    Download the Freedom Mortgage app on
                </TypographyBase>
                <LinkBase href={smartLink} target="_blank" underline="none">
                    <StackBase gap="0.5rem" direction="row">
                        <GooglePlayIcon sx={{ width: '1.146rem', height: '1.25rem' }} />
                        <TypographyBase color="white" variant="paragraph">
                            Google Play
                        </TypographyBase>
                        <AppStoreIcon sx={{ width: '1.094rem', height: '1.25rem' }} />
                        <TypographyBase color="white" variant="paragraph">
                            App Store
                        </TypographyBase>
                    </StackBase>
                </LinkBase>
            </BoxBase>
            <StackBase
                spacing="1rem"
                padding="1rem"
                alignItems="flex-start"
                sx={theme => ({
                    background: theme.palette.surfaceDark.main
                })}
            >
                <StackBase direction="row" justifyContent="space-between" width="100%">
                    <TypographyBase variant="caption" color="white" maxWidth="200px">
                        951 Yamato Road, Boca Raton,
                        <br />
                        FL 33431 United States.
                    </TypographyBase>
                    <StackBase direction="row" sx={{ flexWrap: 'wrap', width: '337px' }}>
                        {footerLinks.map(({ link, text }, index) => {
                            return (
                                <StackBase direction="row" key={index}>
                                    <LinkBase
                                        href={link}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        variant="caption"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            color: 'text.main',
                                            '&:hover': { color: 'text.main' }
                                        }}
                                    >
                                        {text}
                                    </LinkBase>
                                    {footerLinks.length !== index + 1 && (
                                        <TypographyBase
                                            variant="caption"
                                            color="text.main"
                                            sx={{ display: 'flex', alignItems: 'center', marginX: theme.spacing(1) }}
                                        >
                                            |
                                        </TypographyBase>
                                    )}
                                </StackBase>
                            );
                        })}
                    </StackBase>
                </StackBase>
                <StackBase
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'space-between',
                        flexDirection: 'row',
                        width: '100%'
                    }}
                >
                    <BoxBase
                        sx={theme => ({
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.625rem'
                        })}
                    >
                        <TypographyBase variant="caption" color="text.main">
                            Lender NMLS ID: 2767.{' '}
                            <LinkBase
                                href={nmlsConsumerLink.link}
                                variant="caption"
                                rel="noopener noreferrer"
                                target="_blank"
                                color="text.main"
                                underline="hover"
                                sx={{ '&:hover': { color: 'text.main' } }}
                            >
                                {nmlsConsumerLink.text}
                            </LinkBase>
                            <br />
                            Equal Housing Opportunity.
                        </TypographyBase>
                        <EqualOpportunityIcon sx={{ width: '1.875rem', height: '2.063rem' }} />
                    </BoxBase>
                    <BoxBase sx={theme => ({ display: 'flex', width: '340px', gap: '5px', alignItems: 'center', flexShrink: 0 })}>
                        <CopyrightIcon sx={{ width: '11px', height: '11px', flexShrink: 0 }} />
                        <TypographyBase variant="caption" color="text.main">
                            Freedom Mortgage Corporation.
                        </TypographyBase>
                    </BoxBase>
                </StackBase>
            </StackBase>
        </>
    );
};
export const FooterLayout = ({ showFooterAds = false }: any) => {
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.only('xs'));
    const isTablet = useMediaQuery(theme.breakpoints.down('lg'));

    if (isMobile) return <MobileFooter />;
    if (isTablet) return <TabletFooter />;
    return (
        <>
            {showFooterAds ? (
                <BoxBase
                    sx={theme => ({
                        display: 'flex',
                        padding: theme.spacing(2),
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: theme.spacing(2),
                        background: theme.palette.surface.main
                    })}
                >
                    <TypographyBase variant="paragraph" color="white">
                        Download the Freedom Mortgage app on
                    </TypographyBase>
                    <LinkBase href={smartLink} target="_blank" underline="none">
                        <StackBase gap="0.5rem" direction="row" alignItems="center">
                            <GooglePlayIcon sx={{ width: '1.146rem', height: '1.25rem' }} />
                            <TypographyBase color="white" variant="paragraph">
                                Google Play
                            </TypographyBase>
                            <AppStoreIcon sx={{ width: '1.094rem', height: '1.25rem' }} />
                            <TypographyBase color="white" variant="paragraph">
                                App Store
                            </TypographyBase>
                        </StackBase>
                    </LinkBase>
                </BoxBase>
            ) : null}
            <BoxBase
                sx={theme => ({
                    display: 'flex',
                    padding: theme.spacing(4),
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: theme.spacing(2),
                    background: theme.palette.surfaceDark.main,
                    height: { xs: '14rem', md: '8rem' }
                })}
            >
                <BoxBase
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                        alignSelf: 'stretch',
                        flexDirection: 'row'
                    }}
                >
                    <TypographyBase variant="caption" color="white">
                        951 Yamato Road, Boca Raton, FL 33431 United States.
                    </TypographyBase>

                    <StackBase direction="row" spacing={theme.spacing(1)}>
                        {footerLinks.map(({ link, text }, index) => {
                            return (
                                <React.Fragment key={index}>
                                    <Link
                                        href={link}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        variant="caption"
                                        sx={{ display: 'flex', alignItems: 'center', color: 'text.main', '&:hover': { color: 'white' } }}
                                    >
                                        {text}
                                    </Link>
                                    {footerLinks.length !== index + 1 && (
                                        <TypographyBase variant="caption" color="text.main" sx={{ display: 'flex', alignItems: 'center' }}>
                                            |
                                        </TypographyBase>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </StackBase>
                </BoxBase>
                <BoxBase
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                        alignSelf: 'stretch',
                        flexDirection: 'row'
                    }}
                >
                    <BoxBase
                        sx={theme => ({
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'flex-end',
                            gap: theme.spacing(1)
                        })}
                    >
                        <TypographyBase variant="caption" color="text.main" sx={{ lineHeight: '120%' }}>
                            Lender NMLS ID: 2767.
                            <LinkBase
                                href={nmlsConsumerLink.link}
                                variant="caption"
                                rel="noopener noreferrer"
                                target="_blank"
                                color="white"
                                underline="hover"
                                sx={{ px: theme.spacing(1), '&:hover': { color: 'text.main' } }}
                            >
                                {nmlsConsumerLink.text}
                            </LinkBase>
                            Equal Housing Opportunity.
                        </TypographyBase>
                        <EqualOpportunityIcon sx={{ width: '1.875rem', height: '2.063rem' }} />
                    </BoxBase>
                    <BoxBase
                        sx={theme => ({
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: theme.spacing(0.5)
                        })}
                    >
                        <CopyrightIcon sx={{ width: '0.6875rem', height: '0.71331rem', mb: '0.05rem' }} />
                        <TypographyBase variant="caption" color="text.main">
                            Freedom Mortgage Corporation.
                        </TypographyBase>
                    </BoxBase>
                </BoxBase>
            </BoxBase>
        </>
    );
};
